import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_TAXES](state, data) {
    state.allTaxes = data
  },
}
